export default "__VITE_ASSET__sk2L0Wn___"